import React from 'react';
import { Box } from '@material-ui/core';
import { AppDetailsHeader } from './components/AppDetailsHeader';
import { AppDetailsKeyBenefits } from './components/AppDetailsKeyBenefits';
import { AppDetailsAbout } from './components/AppDetailsAbout';
import { AppDetailsPricingPlan } from './components/AppDetailsPricingPlan';
import { AppDetailsScreenshots } from './components/AppDetailsScreenshots';
import { PublicAppListing } from '../../../types/generated';
import Helmet from 'react-helmet';

export interface IAppDetailsView {
    listing: PublicAppListing;
}

export const AppDetailsView = ({ listing }: IAppDetailsView) => {
    return (
        <Box>
            <Helmet>
                <meta itemProp="name" content={listing?.name} />
                <meta itemProp="description" content={listing?.tagLine} />
                <meta itemProp="image" content={listing?.icon?.sourceUrl} />
                <meta name="description" content={listing?.tagLine} />

                <meta property="og:type" content="website" />
                <meta property="og:title" content={listing?.name} />
                <meta property="og:description" content={listing?.tagLine} />
                <meta property="og:image" content={listing?.icon?.sourceUrl} />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={listing?.name} />
                <meta name="twitter:description" content={listing?.tagLine} />
                <meta name="twitter:image" content={listing?.icon?.sourceUrl} />
            </Helmet>

            <AppDetailsHeader listing={listing} />
            <AppDetailsKeyBenefits listing={listing} />
            <AppDetailsAbout listing={listing} />
            <AppDetailsScreenshots listing={listing} />
            <AppDetailsPricingPlan listing={listing} />
        </Box>
    );
};
